import { TApplicationState } from 'shared/types/redux';
import { ISpecificationItem } from '../../types/newbuilding/specification';

export const specificationsSelector = (state: TApplicationState): ISpecificationItem[] => {
  return state.newbuilding.specifications;
};
